module.exports = __webpack_public_path__ + "img/icon-language.7b715c0d.svg";